<template>
    <div class="loading-block has-text-grey has-text-centered">
        <i class="fas fa-spinner fa-spin"></i>
        <p>{{ message }}</p>
    </div>
</template>

<script>
    export default {
        name: "LoadingBlock",
        props: {
            message: String,
        }
    }
</script>

<style lang="scss" scoped>
    .loading-block {
        cursor: wait;
    }
</style>
